import type { CityConfig } from "../city-template/types";

export const lebanonMOConfig: CityConfig = {
  city: "Lebanon",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "lebanon-mo",
  route: "/cities/lebanon-mo",
  title: "Emergency Passport Lebanon, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Lebanon, MO — as fast as 24 hours. Serving Laclede County and the Ozark region. A+ BBB rated registered State Dept. courier serving Lebanon, Waynesville, Richland, and south-central Missouri. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Lebanon, MO",
  heroSubtitle: "Route 66 road trip turns international with expired passport? Ozark adventure to Canada next week and documents aren't ready? Laclede County business trip to Mexico City in two weeks? We help Lebanon residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Lebanon%20Missouri%20Laclede%20County%20historic%20Route%2066%20corridor%20passing%20through%20city%20downtown%20district%20with%20vintage%20charm%20Ozark%20landscape%20Bennett%20Spring%20State%20Park%20trout%20fishing%20historic%20buildings%20surrounding%20rolling%20hills%20green%20forests%20southern%20Missouri%20Heartland%20professional%20drone%20photography%20golden%20hour%20warm%20light&width=1800&height=700&seq=lebanon-mo-hero-2026&orientation=landscape",
  heroImageAlt: "Lebanon Missouri Route 66 corridor Ozark landscape Laclede County at golden hour",
  geoPosition: "37.6806;-92.6637",
  geoPlacename: "Lebanon, Missouri",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 510 miles northeast of Lebanon via I-44/I-55",
  },
  nearbyCitiesZips: [
    { name: "Lebanon", zips: "65536" },
    { name: "Waynesville", zips: "65583" },
    { name: "Richland", zips: "65556" },
    { name: "St. Robert", zips: "65584" },
    { name: "Marshfield", zips: "65706" },
    { name: "Camdenton", zips: "65020" },
    { name: "Buffalo", zips: "65622" },
    { name: "Conway", zips: "65632" },
    { name: "Phillipsburg", zips: "65722" },
    { name: "Springfield", zips: "65801, 65804" },
    { name: "Rolla", zips: "65401" },
    { name: "Bolivar", zips: "65613" },
    { name: "Osage Beach", zips: "65065" },
    { name: "Eldon", zips: "65026" },
    { name: "Jefferson City", zips: "65101, 65109" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Laclede County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Route 66 & Ozark Hub", desc: "Serving Lebanon, Waynesville, Richland, and the south-central Ozarks" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Springfield, MO", route: "/cities/springfield-mo" },
    { name: "Fast passport renewal in Columbia, MO", route: "/cities/columbia-mo" },
    { name: "Emergency passport help in Jefferson City, MO", route: "/cities/jefferson-city" },
    { name: "Urgent passport services in St. Louis, MO", route: "/cities/st-louis" },
    { name: "Passport courier services in Kansas City, MO", route: "/cities/kansas-city" },
    { name: "Same-day passport help in Chicago, IL", route: "/cities/chicago" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Lebanon remotely via secure courier. We do not have a walk-in office in Lebanon — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Laclede County, the Route 66 corridor, and south-central Missouri.",
  fpcOfficeAddress: "1200 Main St, Kansas City, Missouri 64105",
  fpcOfficeDistance: "Serving all of Laclede County including Lebanon, Conway, Phillipsburg, and the south-central Missouri Ozark region",
  serviceAreaIntro: "From the historic Route 66 corridor winding through Lebanon and the trout-filled waters of Bennett Spring State Park to the nearby Fort Leonard Wood military installation and the beautiful Missouri Ozarks landscape, from the agriculturally rich Laclede County communities to the Gateway to the Ozarks along I-44 — Fast Passport Center serves the entire south-central Missouri region. We regularly help Route 66 travelers, Fort Leonard Wood families, and Laclede County residents get their passports fast without the drive to Chicago, St. Louis, or Kansas City.",
  nearbyCitiesIntro: "We serve all Lebanon neighborhoods and the surrounding area including Waynesville, Richland, St. Robert, Marshfield, and Camdenton. If you are anywhere in Laclede County, Pulaski County, or the central Ozarks, we have you covered.",
  howItWorksIntro: "Most Lebanon travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Lebanon travelers face significant distances to any regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Lebanon and Laclede County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Lebanon? Here are the most common ones we hear from Ozark travelers.",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (Missouri Vital Records)", url: "https://health.mo.gov/data/vitalrecords/", desc: "Missouri Department of Health — Vital Records for birth and death certificates statewide" },
    { label: "Marriage Licenses (Laclede County Clerk)", url: "https://www.lacledecountymissouri.com/", desc: "Laclede County Circuit Clerk for Lebanon and Laclede County" },
    { label: "Divorce Decrees (Laclede County Circuit Court)", url: "https://www.courts.mo.gov/", desc: "Laclede County Circuit Court for divorce decree records" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Missouri vital records online via VitalChek" },
  ],
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/drivers/",
  dmvLabel: "Missouri DOR — Driver License Bureau",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Lebanon travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Wayne H.",
      location: "Lebanon, MO",
      rating: 5,
      text: "Retirement trip driving the whole Route 66 — only we kept going into Mexico! My passport had expired. Fast Passport Center got renewal done in 27 hours. From Lebanon's Route 66 to the open road to Tijuana. Legendary service!",
      service: "Passport Renewal",
    },
    {
      name: "Janelle C.",
      location: "Richland, MO",
      rating: 5,
      text: "Bennett Spring trout fishing guide trip in Patagonia — needed passport in 4 days. Fast Passport Center handled my emergency documents in 25 hours. Ozark guides, this is the service you need!",
      service: "Emergency Passport",
    },
    {
      name: "Ruth Ann P.",
      location: "Conway, MO",
      rating: 5,
      text: "Family reunion in Ireland and both kids needed first passports. Fast Passport Center guided us through the child process — done in 4 days. Laclede County's best passport service, hands down!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "lebanon-1",
      name: "Lebanon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "217 E Commercial St",
      city: "Lebanon",
      state: "MO",
      zip: "65536",
      phone: "(417) 532-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Lebanon",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Lebanon facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "lebanon-2",
      name: "Laclede County Circuit Clerk",
      type: "County Government Passport Acceptance",
      address: "200 N Adams Ave",
      city: "Lebanon",
      state: "MO",
      zip: "65536",
      phone: "(417) 532-2471",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Lebanon Courthouse",
      website: "https://www.lacledecountymissouri.com",
      websiteLabel: "Laclede County Circuit Clerk",
      notes: "County seat with passport acceptance services. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "lebanon-3",
      name: "Waynesville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "301 North St",
      city: "Waynesville",
      state: "MO",
      zip: "65583",
      phone: "(573) 774-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles east of Lebanon",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Waynesville and Fort Leonard Wood area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "lebanon-4",
      name: "Marshfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "110 S Crittenden St",
      city: "Marshfield",
      state: "MO",
      zip: "65706",
      phone: "(417) 468-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles southwest of Lebanon",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Webster County area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "lebanon-5",
      name: "Camdenton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "20 S Court St",
      city: "Camdenton",
      state: "MO",
      zip: "65020",
      phone: "(573) 346-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles north of Lebanon",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Camden County and Lake of the Ozarks area. Appointment recommended.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 6+ hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Lebanon photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Laclede County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Lebanon applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Ozark families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Lebanon travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Lebanon." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Lebanon address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Lebanon before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Lebanon for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 6-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Lebanon?", a: "Fast Passport Center offers fast passport renewal in Lebanon in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Lebanon?", a: "The nearest regional passport agency to Lebanon is the Chicago Passport Agency, approximately 510 miles northeast via I-44/I-55. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Lebanon without any in-person agency visit required." },
    { q: "Do you serve the Route 66 corridor and Fort Leonard Wood area?", a: "Absolutely. Fast Passport Center serves the entire Route 66 corridor through Laclede County and the nearby Fort Leonard Wood military community. Our courier service provides expedited passport processing for Ozark travelers and Pulaski County military families." },
    { q: "Can I get a same-day passport appointment near Lebanon?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — a 6+ hour drive from Lebanon — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Laclede County residents." },
    { q: "Do you serve the entire Ozarks region?", a: "Absolutely. Fast Passport Center serves the entire south-central Missouri Ozarks including Lebanon, Waynesville, Richland, Marshfield, Camdenton, and surrounding areas. Our courier service works seamlessly from any address in Laclede, Pulaski, Camden, or Webster counties." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Lebanon with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Can I expedite a child passport in Lebanon?", a: "Yes. Fast Passport Center expedites child passports in Lebanon for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Laclede County and Route 66 families through the entire process." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Lebanon", address: "1800 S Jefferson Ave, Lebanon, MO 65536", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Lebanon", address: "1200 S Jefferson Ave, Lebanon, MO 65536", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Marshfield", address: "1201 Spur Dr, Marshfield, MO 65706", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walmart Supercenter — St. Robert", address: "185 Saint Robert Blvd, St. Robert, MO 65584", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Lebanon License Office",
      address: "240 N Adams Ave, Lebanon, MO 65536",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Most convenient for Lebanon and Laclede County residents.",
      featured: true,
    },
    {
      name: "Missouri DOR — St. Robert License Office",
      address: "393 Old Rte 66, St. Robert, MO 65584",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Fort Leonard Wood area and Pulaski County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Missouri DOR — Marshfield License Office",
      address: "202 S Crittenden St, Marshfield, MO 65706",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Webster County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SGF",
      name: "Springfield-Branson National Airport",
      distance: "55 miles southwest of Lebanon",
      address: "2300 N Airport Blvd, Springfield, MO 65802",
      note: "Major airport for southwest Missouri. About 1 hour from Lebanon via I-44.",
      flightUrl: "https://www.flyspringfield.com/",
      flightLabel: "SGF Airport",
      featured: true,
    },
    {
      code: "TBN",
      name: "Waynesville-St. Robert Regional Airport",
      distance: "35 miles east of Lebanon",
      address: "501 Iowa Ave, Fort Leonard Wood, MO 65473",
      note: "Regional airport serving Fort Leonard Wood. About 40 minutes from Lebanon via I-44.",
      flightUrl: "https://www.flytbn.com/",
      flightLabel: "TBN Airport",
      featured: false,
    },
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "175 miles northeast of Lebanon",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major international airport with worldwide connections. About 2 hours 45 minutes from Lebanon.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Airport",
      featured: false,
    },
  ],
};